// extracted by mini-css-extract-plugin
export default {"rating":"GJ-z","numberOfStars":"HJ-z","count":"IJ-z","barGraphSpacing":"JJ-z","barGraph":"KJ-z"};